module.exports = __webpack_public_path__ + "static/media/fb.9a6f9446.svg";